
// @param {string} dataElemetId - The data attribute id of the dom element to get the data from i.e. "data-course-ai-content-evaluator"
// @returns {object} - The data attributes from the dom element
export default (dataElementAttributeId) => {
  // get the dom element containing the data attribute `[${dataElementId}]`
  const domElement = document.querySelector(`[${dataElementAttributeId}]`);
  if (!domElement) { return {}; }
  return domElement.dataset;
};